import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function EditExpense() {
  const [amount, setAmount] = useState(0);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState(new Date());

  const [isLoading, setIsLoading] = useState(true);

  let { eid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/expenses/${eid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setTitle(response.data.expense.title);
      setAmount(response.data.expense.amount);
      setDate(new Date(response.data.expense.created_at));
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleAmountChange = (evt) => {
    setAmount(evt.target.value);
  };

  const handleTitleChange = (evt) => {
    setTitle(evt.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/expenses/${eid}`,
        data: {
          title: title,
          amount: amount,
          approver: state.userId,
          date: date,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/expenses");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="new-expense">
        <Col>
          <h4>Editar egreso</h4>
        </Col>
        <Col className="new-expense-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Titulo"
                onChange={handleTitleChange}
                value={title}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="number"
                placeholder="Cantidad"
                onChange={handleAmountChange}
                value={amount}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <DatePicker selected={date} onChange={(date) => setDate(date)} />
            </Form.Group>
            <Form.Group>
              <Button variant="info" onClick={handleSubmit}>
                Guardar
              </Button>
              <Button variant="danger" onClick={() => navigate("/expenses")}>
                Cancelar
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default EditExpense;
